module.exports = __webpack_public_path__ + "static/media/QG.0f10bdb6.png";